// @flow

import type { PendingIncomingPayment } from './types';

function getBalotoUrl(incomingPayment: PendingIncomingPayment): ?string {
  return incomingPayment['baloto_url'];
}

export function getSafeBalotoUrl(incomingPayment: PendingIncomingPayment): string {
  const balotoUrl = getBalotoUrl(incomingPayment);

  if (!balotoUrl)
    throw new Error('Baloto: no baloto url in incoming payment');

  return balotoUrl;
}
